import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';
import { SelectProps } from '@mui/material/Select/Select';
import { map } from 'lodash';
import { ComponentType } from 'react';
import { useTranslation } from 'react-i18next';
import { Roles } from '../../../enums/roles.enum';
import { useAuth } from '../../../hooks';

interface RolesSelectProps extends SelectProps {
  className?: string;
  error?: boolean;
  helperText?: string;
  InputProps?: Record<string, any>;
}

export const RolesSelect: ComponentType<RolesSelectProps> = ({
  label,
  error = false,
  helperText,
  InputProps,
  ...props
}) => {
  const { t } = useTranslation();
  const { isOrganizationAdmin } = useAuth();

  let roles = [...Object.keys(Roles)];
  if (isOrganizationAdmin) {
    roles = [Roles.ORGANIZATION_ADMIN, Roles.APPLICANT];
  }

  const options = map(roles, (role, key) => (
    <MenuItem value={role} key={key}>
      {t(`role.${role}`)}
    </MenuItem>
  ));

  return (
    <FormControl error={error} fullWidth>
      <InputLabel>{label}</InputLabel>
      <Select label={label} {...props}>
        {options}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};
